import HomeView from "../modules/home/views/HomeView.vue";

export default [
  {
    path: "/:town",
    name: "home",
    component: HomeView,
  },
];
